import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "truncate",
  standalone: false
})
export class TruncatePipe implements PipeTransform {
  transform(value: string, length: number, chars?: number): string {
    if (value && value.length > length) {
      if (chars) {
        return `${value.slice(0, chars)}...${value.slice(
          value.length - chars,
          value.length
        )}`;
      }

      return `${value.slice(0, length)}...`;
    }

    return value;
  }
}
